import { cn } from "@/shared/lib/utils";

interface SeparatorProps {
  readonly className?: string;
  readonly orientation?: "horizontal" | "vertical";
  readonly decorative?: boolean;
}

export function Separator({
  className,
  orientation = "horizontal",
  decorative = true,
}: SeparatorProps) {
  return (
    <div
      role={decorative ? "none" : "separator"}
      aria-orientation={decorative ? undefined : orientation}
      className={cn(
        "shrink-0 bg-border",
        orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        className,
      )}
    />
  );
}
